"use client";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "@/components/icons";
import { HeroSkeleton } from "./components/loader";
import Enroll from "../modal/enroll";
import { useSession } from "next-auth/react";
import { useEffect, useState } from "react";

const Hero = ({
  isLoading,
  data,
  status: propsStatus,
}: {
  isLoading: boolean;
  data: any;
  status?: string;
}) => {
  const { status: clientStatus } = useSession();

  const [status, setStatus] = useState<string>(propsStatus ?? "loading");

  useEffect(() => {
    if (clientStatus === "loading") return;
    setStatus(clientStatus);
  }, [clientStatus]);

  const backgroundStyle = {
    background: data?.image
      ? `linear-gradient(90deg, rgba(20, 23, 42, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%), 
         linear-gradient(0deg, rgba(26, 26, 26, 0.40) 0%, rgba(26, 26, 26, 0.40) 100%), 
         url(${data.image}) lightgray 50% / cover no-repeat`
      : `linear-gradient(90deg, rgba(20, 23, 42, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%), 
         linear-gradient(0deg, rgba(26, 26, 26, 0.40) 0%, rgba(26, 26, 26, 0.40) 100%)`,
  };

  return (
    <div
      className="flex min-h-screen w-full flex-col pt-20 lg:pt-32"
      style={backgroundStyle}
    >
      <div className="flex flex-1 items-center">
        {isLoading ? (
          <HeroSkeleton />
        ) : (
          <div className="container flex flex-col items-start gap-12 py-10 lg:py-20">
            <div className="flex max-w-[1098px] flex-col gap-4">
              <p className="text-3xl font-medium text-slate-50">
                Start training for <span className="font-bold">$549</span>
              </p>
              <h2 className="font-vollkorn text-5xl leading-[60px] font-semibold text-white italic lg:text-7xl lg:leading-[90px]">
                {data?.title}
              </h2>
              <p className="text-base font-normal text-slate-50 lg:text-3xl">
                {data?.description}
              </p>
            </div>
            {status === "unauthenticated" && (
              <Enroll>
                <Button
                  variant="outline"
                  className="w-full rounded-full bg-transparent text-white lg:w-fit"
                  size="2xl"
                >
                  Enroll Now
                  <ArrowUpRight />
                </Button>
              </Enroll>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero;
